module.exports = __webpack_public_path__ + "static/media/C4.ba8fd669.jpg";